import {
  CreatePreReleaseSpotifyCampaignBody,
  CreateSpotifyCampaignBody,
} from 'src/Redux/spotify-campaignApi'
import { AddNewTikTokCampaignBody } from 'src/Redux/createNewCampaignApi'
import { CreateAdCampaignBody } from 'src/Redux/ad-campaignApi'

const STORAGE_KEY = 'pendingCampaignData'

export type PendingCampaignData =
  | { platform: 'spotify'; body: CreateSpotifyCampaignBody }
  | {
      platform: 'spotify-pre-release'
      body: CreatePreReleaseSpotifyCampaignBody
    }
  | { platform: 'tiktok'; body: AddNewTikTokCampaignBody }
  | { platform: 'meta'; body: CreateAdCampaignBody }

export const persistPendingCampaignData = (data: PendingCampaignData): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
}

export const readPendingCampaignData = (): PendingCampaignData | null => {
  const raw = localStorage.getItem(STORAGE_KEY)
  if (!raw) {
    return null
  }
  try {
    return JSON.parse(raw) as PendingCampaignData
  } catch {
    return null
  }
}

export const clearPendingCampaignData = (): void => {
  localStorage.removeItem(STORAGE_KEY)
}
